import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { QuotationRoutingModule } from './quotation-routing.module';
import { ResourcesModule } from '../resources/resources.module';
import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { InputNumberModule } from 'primeng/inputnumber';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { PanelMenuModule } from 'primeng/panelmenu';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { ToastModule } from 'primeng/toast';
import { CheckboxModule } from 'primeng/checkbox';
import { TagModule } from 'primeng/tag';

import { CotizacionComponent } from './cotizacion/cotizacion.component';
import { CotizacionDetallleComponent } from './cotizacion-detallle/cotizacion-detallle.component';
import { ListadoCotizacionComponent } from './listado-cotizacion/listado-cotizacion.component';
import { CardModule } from 'primeng/card';
import { MessagesModule } from 'primeng/messages';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SelectModule } from 'primeng/select';
import { DatePickerModule } from 'primeng/datepicker';


@NgModule({
  declarations: [CotizacionComponent, CotizacionDetallleComponent, ListadoCotizacionComponent],
  imports: [
    CommonModule,
    QuotationRoutingModule,
    AccordionModule,
    AutoCompleteModule,
    InputNumberModule,
    ResourcesModule,
    FormsModule,
    ReactiveFormsModule,
    SelectModule,
    InputTextModule,
    PanelMenuModule,
    ButtonModule,
    DialogModule,
    ToastModule, CheckboxModule,
    TagModule,
    CardModule,
    DatePickerModule,
    MessagesModule,
    RadioButtonModule
  ]
})
export class QuotationModule { }
